import {gsap} from "gsap";


const animationEnterFromSingleProject = (next_container, current_container) => {
    // console.log("SingleProject animation ENTER from another project !!");

    // couleur du projet précédent
    const mask_current = current_container.querySelector("#project_image_mask");
    const color_mask_current = mask_current.dataset.projectcolor;


    // Element à animer
    const body_el = document.body;
    const mask = next_container.querySelector("#project_image_mask");
    const color_mask = mask.dataset.projectcolor;

    gsap.set(next_container, {alpha:1})
     gsap.set([body_el, mask], {backgroundColor:color_mask_current})
     gsap.set( mask, {width:'100%'})
    gsap.set("#primary_section", {alpha:0})
    gsap.set("#scrollToContentLink", {alpha:0, y:100})

    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power1.out",
        },
    });
    tl.to([body_el, mask], {backgroundColor:color_mask, duration:.75})
    tl.to("#primary_section", {alpha:1, duration:.5})
    tl.to(mask, {width:'80%', duration:.5}, '-=.5')
    tl.to("#scrollToContentLink", {alpha:1, y:0,duration:.5})
    //tl.to(next_container, {alpha:1})


    //pour dev
    tl.timeScale( 1 );
    return tl;
}

export default animationEnterFromSingleProject;
